import { addCpfMask, generateAvatarInitialsImage } from '@repo/ui';
import { PerformanceReportForProfessionalsDetailedRow } from 'presentation/app/modules/Reports/models/performance-report-for-professionals';
import { TableColumn } from 'react-data-table-component';

export const makePerformanceReportForProfessionalsColumns =
  (): TableColumn<PerformanceReportForProfessionalsDetailedRow>[] => {
    const columns: TableColumn<PerformanceReportForProfessionalsDetailedRow>[] =
      [
        {
          id: 1,
          name: 'Profissional',
          sortable: true,
          grow: 2,
          cell: (row) => {
            const professionalName = row.professional.name || '-';
            const fallbackAvatar = generateAvatarInitialsImage(
              professionalName,
              40,
            );

            return (
              <div className="d-flex align-items-center gap-3 py-2">
                <img
                  src={row.professional.photo || fallbackAvatar}
                  alt={professionalName}
                  style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '999px',
                    objectFit: 'cover',
                  }}
                />

                <div>
                  <div className="fw-semibold text-body">
                    {professionalName}
                  </div>
                  <div className="text-muted fs-12">
                    {addCpfMask(row.professional.cpf)}
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          id: 2,
          name: 'Vínculo',
          sortable: true,
          selector: (row) => row.professional.employmentRelationship || '-',
        },
        {
          id: 3,
          name: 'CH Semanal',
          sortable: true,
          selector: (row) => row.professional.weeklyWorkload || '-',
        },
        {
          id: 4,
          name: 'Atividades Realizadas',
          sortable: true,
          selector: (row) => row.performance.finishedActivitiesCount,
          cell: (row) => (
            <span className="fw-semibold text-success">
              {row.performance.finishedActivitiesCount}
            </span>
          ),
        },
        {
          id: 5,
          name: 'Atividades Perdidas Just. Validadas',
          sortable: true,
          selector: (row) =>
            row.performance.missedJustifiedValidatedActivitiesCount,
          cell: (row) => (
            <span className="fw-semibold text-danger">
              {row.performance.missedJustifiedValidatedActivitiesCount}
            </span>
          ),
        },
        {
          id: 6,
          name: 'Avaliações',
          sortable: true,
          selector: (row) => row.performance.evaluationsCount,
        },
        {
          id: 7,
          name: 'Último login',
          sortable: true,
          selector: (row) => row.professional.lastLogin || '-',
          grow: 1.2,
        },
      ];

    return columns;
  };
